import React, { useState, useEffect } from "react";
import axios from "axios";

const CustomersPage = ({ agentName }) => {
  const [groupedCustomers, setGroupedCustomers] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const baseURL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const accessToken = sessionStorage.getItem("access_token");
    axios
      .get(`${baseURL}/fetchCustomers`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        console.log("Fetched Data:", response.data);

        // Group customers by agent name
        const grouped = response.data.reduce((acc, customer) => {
          const agent = customer.admin_name.toLowerCase();
          if (!acc[agent]) {
            acc[agent] = [];
          }
          acc[agent].push(customer);
          return acc;
        }, {});

        console.log("Grouped Customers:", grouped); // Debug: Check grouped data

        setGroupedCustomers(grouped);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching customer data:", err);
        setError("Error fetching data. Please try again.");
        setLoading(false);
      });
  }, []);

  
  if (loading) {
  return (
    <div className="flex justify-center items-center h-64">
      <p className="text-lg font-semibold text-gray-600">Loading…</p>
    </div>
  );
}
  if (error) {
    return <div className="text-red-500 text-center">{error}</div>;
  }

  // Function to render customers table with alternating gray and white rows, first row white
  const renderCustomerTable = (customers) => (
    <div className="overflow-x-auto mb-6">
      <table className="table-auto w-full border-collapse border border-gray-300 bg-white shadow-md rounded-lg">
        <thead className="bg-gray-200">
          <tr>
            <th className="border border-gray-300 px-4 py-2 w-10">S.No</th>
            <th className="border border-gray-300 px-4 py-2 w-1/2">
              Customer Name
            </th>
            <th className="border border-gray-300 px-4 py-2 w-1/4">
              Contact No
            </th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer, index) => {
            // First row white, then alternate between gray and white
            const rowColor = index % 2 === 0 ? "bg-white": "bg-gray-100" ;
            return (
              <tr
                key={index}
                className={`hover:bg-gray-100 border-b border-gray-300 ${rowColor}`}
              >
                <td className="border border-gray-300 px-4 py-2 text-center">
                  {index + 1}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {customer.customername} - {customer.tamilname}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-center">
                  {customer.contactno}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );

  // Normalize agentName to ensure it's a string
  const normalizedAgentName = String(agentName || "").toLowerCase();

  return (
    <div className="bg-gray-50 min-h-screen p-6">
      <h2 className="text-2xl text-center font-bold">Agent Customers</h2>
      {normalizedAgentName === "all" ? (
        Object.entries(groupedCustomers).length > 0 ? (
          Object.entries(groupedCustomers).map(([agent, customers]) => (
            <div key={agent} className="mb-8">
              <h2 className="text-xl font-bold mb-4"> {agent}</h2>
              {customers.length > 0 ? (
                renderCustomerTable(customers)
              ) : (
                <p className="text-gray-500">
                  No customers found for this agent.
                </p>
              )}
            </div>
          ))
        ) : (
          <p className="text-center">No customers available.</p>
        )
      ) : groupedCustomers[normalizedAgentName] &&
        groupedCustomers[normalizedAgentName].length > 0 ? (
        <div>
          <h2 className="text-xl font-bold mb-4"> {agentName}</h2>
          {renderCustomerTable(groupedCustomers[normalizedAgentName])}
        </div>
      ) : (
        <p className="text-gray-500">No customers found for this agent.</p>
      )}
    </div>
  );
};

export default CustomersPage;



